import { render, staticRenderFns } from "./AbsenceToColaborator.vue?vue&type=template&id=2acca84e"
import script from "./AbsenceToColaborator.vue?vue&type=script&lang=js"
export * from "./AbsenceToColaborator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports